export default "__VITE_ASSET__xfyZ0uiU__"